module.exports = __webpack_public_path__ + "img/yancheng_s.b4274ae.png";